<template>
	<BaseAuthUser v-slot="{isLoggedIn, urls}">
		<div class="auth-userbox" :class="[{'active': userBoxDropdown && tabletBreakpoint}]"  @click="userBoxDropdown = !userBoxDropdown" ref="aw">
			<ClientOnly>
				<div class="auth-userbox-hover" v-if="isLoggedIn">
					<NuxtLink :to="urls.auth">
						<span><BaseCmsLabel code="my_profile" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_my_webshoporder">
						<span><BaseCmsLabel code="my_orders" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth+'#coupons'">
						<span><BaseCmsLabel code="auth_coupons" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_wishlist">
						<span><BaseCmsLabel code="auth_wishlist" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_edit">
						<span><BaseCmsLabel code="edit_profile" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_change_password">
						<span><BaseCmsLabel code="change_password" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_logout+'?redirect=/'">
						<span><BaseCmsLabel code="logout" /></span>
					</NuxtLink>
				</div>
				<div v-else class="auth-userbox-hover">
					<NuxtLink :to="urls.auth_login">
						<span><BaseCmsLabel code="login" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_signup">
						<span><BaseCmsLabel code="signup" /></span>
					</NuxtLink>
					<NuxtLink :to="urls.auth_forgotten_password" class="button" data-auth_login="forgotten_password" data-siteform_response="show_hide" data-siteform_response_hide="-1">
						<BaseCmsLabel code="forgotten_password_userbox" />
					</NuxtLink>
				</div>
			</ClientOnly>
		</div>
	</BaseAuthUser>
</template>

<script setup>
	const {onClickOutside} = useDom();
	const {tabletBreakpoint} = inject('rwd');
	const userBoxDropdown = ref(false);
	const aw = ref();

	onClickOutside(aw, () => {
		userBoxDropdown.value = false;
	});

	const route = useRoute();
	watch(
		() => route.fullPath,
		() => {
			userBoxDropdown.value = false;
		}
	);
</script>

<style lang="less" scoped>
	.auth-userbox{
		width: 50px; height: 50px; transition: var(--transition); cursor: pointer; position: relative; border-left: 1px solid rgba(255,255,255,0.2); border-right: 1px solid rgba(255,255,255,0.2); position: relative;
		a{text-decoration: none;}
		&:before{.pseudo(50px,50px); font: 22px/22px var(--fonti); .icon-user; color: white; display: flex; align-items: center; justify-content: center;}
		&.active{
			.auth-userbox-hover{visibility: visible; opacity: 1; max-height: 500px;}
		}
		@media(min-width: @h){
			&:hover{
				background: #472266;
				.auth-userbox-hover{visibility: visible; opacity: 1; max-height: 500px;}
			}
		}
		@media (max-width: @l){
			width: 44px; height: 44px;
			&:before{font: 20px/20px var(--fonti); width: 44px; height: 44px;}
		}
		@media (max-width: @tp){
			right: 106px; width: 20px; height: 56px; position: absolute; left: unset; border: unset;
			&:before{font: 24px/24px var(--fonti); width: 20px; height: 56px;}
		}
	}
	.auth-userbox-hover{
		visibility: hidden; opacity: 0; max-height: 0; background: white; padding: 20px 30px; font-size: 18px; line-height: 30px; position: absolute; box-shadow: 0 10px 50px 0 rgba(85,41,122,0.28); top: 50px; .transition(opacity); display: flex; flex-flow: column; left: -89px; width: 220px;  z-index: 9999; border-radius: var(--borderRadius);
		a{
			display: block; color: var(--textColor); text-align: center; transition: var(--transition);
			@media(min-width: @h){
				&:hover{color: var(--primaryColor); text-decoration: underline;}
			}
		}
		&:before{.pseudo(6px,6px); transform: rotate(45deg); background: white; top: -3px; left: 110px; box-shadow: 0 0 40px 0 rgba(0,0,0,.1); }
		@media (max-width: @t){
			padding: 18px 15px; font-size: 16px; line-height: 28px; top: 44px; left: -97px; width: 180px;
			&:before{left: 115px;}
		}
		@media (max-width: @tp){
			font-size: 14px; line-height: 26px; top: 56px; left: -80px;; width: 180px; padding: 18px 15px; z-index: 9999999;
			&:before{left: 87px;}
		}
	}

</style>
